import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import * as AuthServices from '../services/auth.service';
import { ATLEAST_ONE_CAPITAL_REGEX, ATLEAST_ONE_NUMBER_REGEX, ATLEAST_ONE_SMALL_REGEX, ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, SWAL_SETTINGS } from "../../../utils/Constants";
import { PHONE_VALIDATION } from "../../../utils/CommonValidatiobn";
import { handleServerValidations } from "../../../utils/commonfunction";
import PhoneInput from "../../../utils/PhoneInput";
import { useTranslation } from "react-i18next";

function SignupSeller() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility (for demonstration)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const validationSchema = Yup.object().shape({
        name: Yup.string()
          .required(t("vaildation.name")),
        display_name: Yup.string()
          .required(t("vaildation.display")),
        email: Yup.string()
            .trim()
            .email(t("vaildation.email_required"))
            .matches(
              /^[a-zA-Z0-9._%+-]+@[A-Za-z0-9-]+\.[A-Za-z]{2,63}$/,
              t("vaildation.valid_email_address")
            )
            .required(t("vaildation.email_required")),
        address: Yup.string()
          .required(t("vaildation.address")),
        phone_number: PHONE_VALIDATION,
        whatsapp_phone_number: PHONE_VALIDATION,
        password: Yup.string()
            .required(t("vaildation.new_password"))
            .matches(ATLEAST_ONE_SMALL_REGEX, t("vaildation.one_small_letter"))
            .matches(ATLEAST_ONE_CAPITAL_REGEX, t("vaildation.one_capital_letter"))
            .matches(ATLEAST_ONE_NUMBER_REGEX, t("vaildation.one_number"))
            .matches(ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, t("vaildation.one_special_char"))
            .min(PASSWORD_MIN_LENGTH, t("vaildation.min_length"))
            .max(PASSWORD_MAX_LENGTH, t("vaildation.max_length")),
        confirm_password: Yup.string().required(t("vaildation.confirm_password")).oneOf([Yup.ref("password"), null], t("vaildation.password_not_match"))
    });
    
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
          name: '',
          display_name: '',
          email: '',
          address: '',
          phone_number: '',
          whatsapp_phone_number: '',
          password: '',
          confirm_password: '',
          profile_image: ''
        },
        validationSchema: validationSchema,
        validateOnBlur: false,
        onSubmit: (values, { setSubmitting, resetForm }) => {
          setSubmitted(true);
          let formData = new FormData();
          
          formData.append("name", values.name);
          formData.append("display_name", values.display_name);
          formData.append("email", values.email);
          formData.append("address", values.address);
          formData.append("password", values.password);
          formData.append("confirm_password", values.confirm_password);
          formData.append("phone_number", values.phone_number);
          formData.append("whatsapp_phone_number", values.whatsapp_phone_number);
          formData.append('profile_image', values.profile_image);

          setSubmitted(false);
          AuthServices
            .signup(formData)
            .then((response) => {
              setSubmitted(true);
  
              if (response.success) {
                // setLocalKey("super_admin", JSON.stringify(response.data));
                // Dispatch(addProfileData(response.data));
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });
                // navigate(`../profile-setup?user_id=${response.data.user_id}`);
                navigate(`../otp-verification?user_id=${response.data.user_id}`);
  
                // resetForm({ values: "" });
                // setUpdateData(!updateData);
  
                
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
              }
            })
            .catch((error) => {
              setSubmitted(true);
              console.log("error ====> ", error);
            });
        },
    });
  
    // console.log(formik.errors);
    
  return (
    <section className="py-8 md:py-12 lg:py-16 form-bg">
      <div className="container">
        <h1 className="headings-h1 text-center text-zinc-950 mb-2">
          {t("signup")}
        </h1>
        <p className="text-center text-zinc-950 mb-8">
          {t("create_account")}
        </p>
        <div className="bg-white p-[15px] md:p-[50px] rounded-[10px] max-w-[650px] shadow-[0px_2px_24px_rgba(0,0,0,0.05)] w-full mx-auto border border-zinc-100">
          <form onSubmit={formik.handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 md:gap-[30px]">
              <div className="form-group">
                <label htmlFor="full-name">{t("full_name")}</label>
                <input
                  id="full-name"
                  type="text"
                  placeholder={t("placeholder.name")}
                  className="form-control-custom"
                  // required
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                 <span className="text-danger text-left d-blockerr-spn">
                  {formik.errors.name && formik.touched.name && formik.errors.name}
                </span>
              </div>

              <div className="form-group">
                <label htmlFor="display-name">{t("display_name")}</label>
                <input
                  id="display-name"
                  type="text"
                  placeholder={t("placeholder.display_name")}
                  className="form-control-custom"
                  // required
                  name="display_name"
                  value={formik.values.display_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <span className="text-danger text-left d-blockerr-spn">
                  {formik.errors.display_name && formik.touched.display_name && formik.errors.display_name}
                </span>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="profile">{t("profile")}</label>
              <div className="relative">
                <input
                  id="profile"
                  accept="image/*"
                  type="file"
                  placeholder={t("placeholder.upload_profile")}
                  className="form-control-custom"
                  // required
                  name="profile_image"
                  onChange={(e) => {
                    formik.setFieldValue("profile_image", e.target.files[0]);
                  }}
                  onBlur={formik.handleBlur}
                />
                <button className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600">
                  <img src="/images/upload.svg" alt="Upload" />
                </button>
              </div>
               <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.profile_image && formik.touched.profile_image && formik.errors.profile_image}
              </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 md:gap-[30px]">
              <div className="form-group">
                <label htmlFor="email">{t("email_address")}</label>
                <input
                  id="email"
                  type="email"
                  placeholder={t("placeholder.email")}
                  className="form-control-custom"
                  // required
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <span className="text-danger text-left d-blockerr-spn">
                  {formik.errors.email && formik.touched.email && formik.errors.email}
                </span>
              </div>

              <div className="form-group">
                <label htmlFor="phone-number">{t("phone")}</label>
                {/* <input
                  id="phone-number"
                  type="text"
                  placeholder="Enter phone number"
                  className="form-control-custom"
                  required
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                /> */}
                <PhoneInput
                  // className="no_spring_input"
                  value={formik?.values?.phone_number}
                  name={'phone_number'} placeholder={t("placeholder.phone")} onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }} onBlur={formik.handleBlur} 
                />
                <span className="text-danger text-left d-blockerr-spn">
                  {formik.errors.phone_number && formik.touched.phone_number && t(formik.errors.phone_number)}
                </span>
              </div>
            </div>

            <div className="form-group">
              <label>{t("whatsapp_no")}</label>
              {/* <input
                id="whatsapp-contact-number"
                type="text"
                placeholder="Enter whatsapp contact number"
                className="form-control-custom"
                required
              /> */}
              <PhoneInput
                value={formik?.values?.whatsapp_phone_number}
                name={'whatsapp_phone_number'} placeholder={t("placeholder.phone")} onChange={(e) => { formik.setFieldValue('whatsapp_phone_number', e?.phone_number) }} onBlur={formik.handleBlur} 
              />
               <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.whatsapp_phone_number && formik.touched.whatsapp_phone_number && t(formik.errors.whatsapp_phone_number)}
              </span>
            </div>

            <div className="form-group">
              <label htmlFor="address">{t("address")}</label>
              <input
                id="address"
                type="text"
                placeholder={t("placeholder.address")}
                className="form-control-custom"
                // required
                name="address"
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.address && formik.touched.address && formik.errors.address}
              </span>
            </div>

            <div className="form-group">
              <label htmlFor="password" className="">
                {t("password")}
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder={t("placeholder.password")}
                  className="form-control-custom !pr-[40px]"
                  // required
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(prev => !prev)}
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                >
                  <img
                    src={showPassword ? "/images/eye2.svg" : "/images/eye1.svg"}
                    alt="Toggle password visibility"
                    className="w-5 h-5"
                  />
                </button>
              </div>
              <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.password && formik.touched.password && formik.errors.password}
              </span>
            </div>

            <div className="form-group">
              <label htmlFor="confirm-password" className="">
                {t("confirm_password")}
              </label>
              <div className="relative">
                <input
                  id="confirm-password"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder={t("placeholder.confirm_password")}
                  className="form-control-custom !pr-[40px]"
                  // required
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(prev =>!prev)}
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                >
                  <img
                    src={showConfirmPassword ? "/images/eye2.svg" : "/images/eye1.svg"}
                    alt="Toggle password visibility"
                    className="w-5 h-5"
                  />
                </button>
              </div>
              <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.confirm_password && formik.touched.confirm_password && t(formik.errors.confirm_password)}
              </span>
            </div>

            {/* Sign up Button */}
            <button type="submit" className="btn btn-pri w-full">
              {t("signup")}
            </button>
          </form>
        </div>

        <div className="mt-8 text-center body-md text-zinc-700">
          {/* Already have an account? */}
          {t("already_account")}
          <a
            href="#"
            className="headings-h6 font-bold text-[var(--secondary-400)] pl-[5px]"
            onClick={()=> navigate('../login')}
          >
              {t("log_in")}
          </a>
        </div>
      </div>
    </section>
  );
}

export default SignupSeller;
